// extracted by mini-css-extract-plugin
export default {"yellowWrapper":"yUjTH__yellowWrapper","redWrapper":"f7Xkb__redWrapper","loadingMsg":"XbVZx__loadingMsg"};